/** Always read live config (do not cache at module load — bundle may init before runtime-config.js). */
export function getRuntimeConfig() {
  if (typeof window === 'undefined') return {};
  return window.__POSCRAFT_CONFIG__ || {};
}

/** Wait until runtime-config.js has set BEARER_TOKEN (avoids flaky PaymentTypes on hard refresh). */
/** Callback PlaceOrder auth header — always read live from runtime-config.js. */
export function getCallbackAuthorizationKey(config = getRuntimeConfig()) {
  return String(config.CALLBACK_AUTHORIZATION_KEY || '').trim();
}

export function waitForRuntimeConfigReady(maxMs = 5000) {
  return new Promise((resolve) => {
    const start = Date.now();
    const check = () => {
      const config = getRuntimeConfig();
      const token = String(config.BEARER_TOKEN || '').trim();
      if (token || Date.now() - start >= maxMs) {
        resolve(config);
        return;
      }
      window.setTimeout(check, 50);
    };
    check();
  });
}
